import React from "react";
import { getPaginationMessage } from "../../utils/common";

const SIBLING_COUNT = 1;

// Builds the list of page numbers to show, using "..." for skipped ranges,
// e.g. [1, "...", 4, 5, 6, "...", 20]
const getPageNumbers = (currentPage, totalPages) => {
  const maxVisible = SIBLING_COUNT * 2 + 5;
  if (totalPages <= maxVisible) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  const left = Math.max(currentPage - SIBLING_COUNT, 2);
  const right = Math.min(currentPage + SIBLING_COUNT, totalPages - 1);
  const pages = [1];

  if (left > 2) pages.push("left-ellipsis");
  for (let i = left; i <= right; i++) pages.push(i);
  if (right < totalPages - 1) pages.push("right-ellipsis");

  pages.push(totalPages);
  return pages;
};

const Pagination = ({
  setCurrentPage,
  TotalPages,
  currentPage,
  TotalEntries,
  perPage,
}) => {
  const totalPages = Math.max(Number(TotalPages) || 0, 1);
  const page = Math.min(Math.max(Number(currentPage) || 1, 1), totalPages);
  const totalEntries = Number(TotalEntries) || 0;

  const goToPage = (e, target) => {
    e.preventDefault();
    if (target < 1 || target > totalPages || target === page) return;
    setCurrentPage(target);
  };

  return (
    <div className="row">
      <div className="col-md-6 ">
        <div className="entries-section justify-content-left">
          <div className="entries-section">
            <p>{getPaginationMessage(totalEntries, perPage, page)} </p>
          </div>
        </div>
      </div>
      <div className="col-md-6 mt-2">
        <div className="justify-content-left">
          <nav aria-label="Page navigation">
            <ul className="pagination justify-content-md-end justify-content-start flex-wrap">
              <li className={`page-item ${page <= 1 ? "disabled" : ""}`}>
                <a
                  className="page-link"
                  href="#!"
                  onClick={(e) => goToPage(e, page - 1)}
                  aria-disabled={page <= 1}
                >
                  Previous
                </a>
              </li>
              {getPageNumbers(page, totalPages).map((item) =>
                typeof item === "number" ? (
                  <li
                    key={item}
                    className={`page-item ${item === page ? "active" : ""}`}
                  >
                    <a
                      className="page-link"
                      href="#!"
                      onClick={(e) => goToPage(e, item)}
                      aria-current={item === page ? "page" : undefined}
                    >
                      {item}
                    </a>
                  </li>
                ) : (
                  <li key={item} className="page-item disabled">
                    <span className="page-link">…</span>
                  </li>
                ),
              )}
              <li
                className={`page-item ${page >= totalPages ? "disabled" : ""}`}
              >
                <a
                  className="page-link"
                  href="#!"
                  onClick={(e) => goToPage(e, page + 1)}
                  aria-disabled={page >= totalPages}
                >
                  Next
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Pagination;
